var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-modal',{attrs:{"id":"privacy-policy-modal","scrollable":"","title":"Privacy Policy","size":"xl","hide-footer":""}},[_c(`${_vm.capitalizeFirstLetter(_vm.locale)}PrivacyPolicyContent`,{tag:"component"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }